import "./ActivityLogWidget.scss";
import type { ActivityLogItemDto } from "@/types/dashboard";
import { FaFileAlt } from "react-icons/fa";

interface Props {
  items: ActivityLogItemDto[];
  className?: string;
}

export default function ActivityLogWidget({ items, className = "" }: Props) {
  return (
    <div className={`dashboard-card activity-log-widget ${className}`}>
      {items.length === 0 && <div className="empty">No recent activity</div>}

      <ul className="list-unstyled">
        {items.slice(0, 7).map((i) => (
          <li key={i.guid}>
            <span className="activity-icon" aria-hidden="true"><FaFileAlt /></span>
            <div className="activity-content">
              <span className="msg">{i.title || i.message}</span>
              {i.title && i.message !== i.title && <span className="activity-detail">{i.message}</span>}
            </div>
            <span className="timestamp">
              {new Date(i.createDt).toLocaleString()}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}